import React from "react";
import { useField } from "formik";

const TextareaField = ({ disable, required, label, hideLabel, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <div className="form-control w-full">
      {hideLabel ? (
        <label htmlFor={props.id || props.name} className="sr-only">
          {label || "Note"}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      ) : (
        <label
          htmlFor={props.id || props.name}
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <textarea
        className={`
          w-full px-4 py-2.5 text-sm
          border border-gray-300 rounded-lg
          focus:ring-2 focus:ring-primary/50
          focus:border-primary
          transition-all duration-200
          placeholder:text-gray-400
          ${disable ? 'bg-gray-100 cursor-not-allowed' : 'bg-white hover:border-gray-400'}
          ${meta.touched && meta.error ? 'border-red-500 focus:ring-red-500/30 focus:border-red-500' : 'border-gray-300'}
        `}
        {...field}
        {...props}
        autoComplete="off"
        disabled={disable}
        rows={5}
        aria-invalid={meta.touched && meta.error ? 'true' : 'false'}
        aria-describedby={meta.touched && meta.error ? `${props.name}-error` : undefined}
      />
      
      {/* Error Message */}
      {meta.touched && meta.error && (
        <p 
          id={`${props.name}-error`}
          className="mt-1 text-sm text-red-600 flex items-center gap-1"
          role="alert"
        >
          <svg className="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
          {meta.error}
        </p>
      )}
    </div>
  );
};

export default TextareaField;
